export default __webpack_public_path__ + "static/media/like-star.c39dc4c9.svg";